<template>
    <div class="pb-xl">
        <div v-if="! emailAccountOrAlias.is_alias">
            <div v-if="emailAccountOrAlias.aliases.length" class="mb-sm text-sm font-semibold">
                {{ lang('Alias','Alias') }}:
            </div>
            <ul class="list-reset">
                <li v-for="alias in emailAccountOrAlias.aliases" class="mb-sm">
                    <remove-email-account-alias-button
                        :email-account="emailAccountOrAlias"
                        :alias="alias"
                        @aliasRemoved="updateEmailAccountOrAlias"
                    />
                    {{ alias }}
                </li>
            </ul>
        </div>

        <div
            class="flex flex-col-reverse md:flex-row md:items-end p-xl bg-neutral-darker rounded-b-lg -mx-lg -mb-xl md:-mb-lg md:-mx-xl"
        >
            <delete-email-account-or-alias-button class="md:mr-auto" :email-account-or-alias="emailAccountOrAlias" />

            <add-email-account-alias-button
                v-if="! emailAccountOrAlias.is_alias"
                class="mb-lg md:mb-0"
                :email-account="emailAccountOrAlias"
                :domain-options="domainOptions"
                @aliasAdded="updateEmailAccountOrAlias"
            />

            <change-email-account-password-button
                v-if="! emailAccountOrAlias.is_alias"
                class="mb-lg md:mb-0 md:ml-xl"
                :email-account="emailAccountOrAlias"
            />

            <edit-email-alias-button
                v-if="emailAccountOrAlias.is_alias"
                class="mb-lg md:mb-0 md:ml-xl"
                :email-alias="emailAccountOrAlias"
            />
        </div>
    </div>
</template>

<script>
    import ChangeEmailAccountPasswordButton from './ChangeEmailAccountPasswordButton';
    import DeleteEmailAccountOrAliasButton from './DeleteEmailAccountOrAliasButton';
    import AddEmailAccountAliasButton from './AddEmailAccountAliasButton';
    import RemoveEmailAccountAliasButton from './RemoveEmailAccountAliasButton';
    import EditEmailAliasButton from './EditEmailAliasButton';

    export default {
        components: {
            ChangeEmailAccountPasswordButton,
            DeleteEmailAccountOrAliasButton,
            AddEmailAccountAliasButton,
            RemoveEmailAccountAliasButton,
            EditEmailAliasButton,
        },

        props: {
            initialEmailAccountOrAlias: {
                type: Object,
                required: true,
            },
            domainOptions: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                emailAccountOrAlias: this.initialEmailAccountOrAlias,
            };
        },

        methods: {
            updateEmailAccountOrAlias(emailAccountOrAlias) {
                this.emailAccountOrAlias = emailAccountOrAlias;
                this.$emit('emailAccountOrAliasUpdated', emailAccountOrAlias);
            },
        },
    };
</script>